import React, { useState } from 'react'
import { css, SerializedStyles } from '@emotion/core'
import { Popover } from 'antd'
import { useTranslation } from 'react-i18next'
import { ReservationTaskHandlingStatus, reservationTaskHandlingStatusLabelKeys } from '@/models/reservation/reservation-task'
import { HANDLING_STATUS_POPOVER_CLASS, HandlingStatusMenu } from './handling-status-menu'
import { RESERVATION_TASK_STATUS_COLORS } from './status-colors'

type Props = {
  value: ReservationTaskHandlingStatus
  disabled: boolean
  onChange: (status: ReservationTaskHandlingStatus) => void
}

export const HandlingStatusSelect: React.FC<Props> = ({ value, disabled, onChange }) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  const button = (
    <button type="button" css={[buttonStyle, buttonColorStyles[value], disabled && disabledButtonStyle]} disabled={disabled}>
      {t(reservationTaskHandlingStatusLabelKeys[value])}
      {!disabled && <img src={require('@/static/images/select_white.svg')} alt="" css={arrowStyle} />}
    </button>
  )
  if (disabled) {
    return button
  }

  return (
    <Popover
      overlayClassName={HANDLING_STATUS_POPOVER_CLASS}
      placement="bottomLeft"
      trigger="click"
      visible={isOpen}
      onVisibleChange={setIsOpen}
      destroyTooltipOnHide
      content={
        <HandlingStatusMenu
          onSelect={status => {
            setIsOpen(false)
            // 同じ値を選んだときは保存しない（一覧と件数の取り直しを増やさないため）
            if (status !== value) {
              onChange(status)
            }
          }}
        />
      }
    >
      {button}
    </Popover>
  )
}

// 角丸はモックと、既存の宿泊ステータスのボタン（approved-status-button.tsx）に合わせる
const buttonStyle = css({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 90,
  height: 26,
  padding: '0 20px 0 8px',
  border: 'none',
  borderRadius: 5,
  color: '#FFFFFF',
  fontSize: 12,
  fontWeight: 'bold',
  cursor: 'pointer',
})

const disabledButtonStyle = css({
  padding: '0 8px',
  cursor: 'default',
})

const arrowStyle = css({
  position: 'absolute',
  right: 8,
})

const buttonColorStyles: Record<ReservationTaskHandlingStatus, SerializedStyles> = {
  [ReservationTaskHandlingStatus.Unhandled]: css({ background: RESERVATION_TASK_STATUS_COLORS.yellow }),
  [ReservationTaskHandlingStatus.InProgress]: css({ background: RESERVATION_TASK_STATUS_COLORS.red }),
  [ReservationTaskHandlingStatus.Completed]: css({ background: RESERVATION_TASK_STATUS_COLORS.lightGray }),
}
